import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { PortalHeading } from "@/pages/portal/PortalLayout";
import { InsStatus } from "@/pages/insurer/InsurerLayout";
import { INS_STATUSES } from "@/lib/insurance";
import { api, fmtDate } from "@/lib/api";

const sel = "h-10 rounded-md border bg-white px-3 text-sm";

export default function AdminInsurance() {
  const [rows, setRows] = useState(null);
  const [insurers, setInsurers] = useState([]);
  const [f, setF] = useState({ status: "", insurer_id: "", date_from: "", date_to: "", q: "" });
  useEffect(() => { api.get("/admin/insurance/insurers").then((r) => setInsurers(r.data.insurers)); }, []);
  useEffect(() => {
    const t = setTimeout(() => {
      const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
      api.get("/admin/insurance/requests", { params }).then((r) => setRows(r.data.requests));
    }, 250);
    return () => clearTimeout(t);
  }, [f]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <div data-testid="admin-insurance-inbox">
      <PortalHeading title="Insurance requests" sub="Requests from every insurer, newest first" />
      <div className="mb-4 flex flex-wrap gap-2">
        <Input placeholder="Search claim ref, insured or reg" value={f.q} onChange={set("q")} className="w-full sm:w-64 bg-white" data-testid="admin-insurance-search" />
        <select value={f.status} onChange={set("status")} className={sel} data-testid="admin-insurance-filter-status">
          <option value="">All statuses</option>{INS_STATUSES.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
        <select value={f.insurer_id} onChange={set("insurer_id")} className={sel} data-testid="admin-insurance-filter-insurer">
          <option value="">All insurers</option>{insurers.map((i) => <option key={i.id} value={i.id}>{i.company_name}</option>)}
        </select>
        <Input type="date" value={f.date_from} onChange={set("date_from")} className="w-auto bg-white" data-testid="admin-insurance-filter-from" aria-label="From date" />
        <Input type="date" value={f.date_to} onChange={set("date_to")} className="w-auto bg-white" data-testid="admin-insurance-filter-to" aria-label="To date" />
      </div>
      <div className="rounded-2xl bg-white overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-insurance-table">
          <thead className="text-left text-xs uppercase tracking-wider text-[#56585E] border-b">
            <tr><th className="p-4">Insurer</th><th className="p-4">Claim ref</th><th className="p-4">Insured</th><th className="p-4">Vehicle</th><th className="p-4">Received</th><th className="p-4">Status</th><th className="p-4">Assigned</th></tr>
          </thead>
          <tbody className="divide-y">
            {(rows || []).map((r) => (
              <tr key={r.id} className="hover:bg-[#F4F4F4]" data-testid={`admin-insurance-row-${r.reference}`}>
                <td className="p-4 font-medium">{r.company_name}</td>
                <td className="p-4 whitespace-nowrap"><Link to={`/admin/insurance/${r.id}`} className="font-semibold text-[#020165] underline" data-testid={`admin-insurance-open-${r.reference}`}>{r.claim_number}</Link><p className="text-[11px] text-[#56585E]">{r.reference}</p></td>
                <td className="p-4">{r.insured_name}</td>
                <td className="p-4 whitespace-nowrap">{r.vehicle?.make} {r.vehicle?.model}<p className="text-xs text-[#56585E]">{r.vehicle?.registration}</p></td>
                <td className="p-4 whitespace-nowrap">{fmtDate(r.created_at)}</td>
                <td className="p-4"><InsStatus status={r.status} />{r.staff_unread > 0 && <span className="ml-2 rounded-full bg-[#F86900] px-2 py-0.5 text-[10px] font-bold text-[#0D141A]" data-testid={`admin-insurance-unread-${r.reference}`}>{r.staff_unread} new msg</span>}</td>
                <td className="p-4 text-[#56585E]">{r.assigned_to?.name || "Unassigned"}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {rows && !rows.length && <p className="p-6 text-sm text-[#56585E]" data-testid="admin-insurance-empty">No insurance requests match.</p>}
      </div>
    </div>
  );
}
